export class MessageResourceKeys {
    public static readonly BALANCED_BETTING_POOL = "balanceBetting";
    public static readonly NO_MORE_BETS = "noMoreBets";
}
